import { supabase } from "@/lib/supabase";
import { categories as mockCategories } from "@/mocks/categories";

export interface AnnouncementCategory {
  id: number;
  name: string;
  slug: string;
  description: string | null;
  icon: string | null;
  image_url: string | null;
  parent_id: number | null;
  sort_order: number;
  is_active: boolean;
}

/** Obtiene las categorías administrables desde la base de datos. */
export async function fetchCategories(): Promise<AnnouncementCategory[]> {
  try {
    const { data, error } = await supabase
      .from("announcement_categories")
      .select("*")
      .order("sort_order", { ascending: true })
      .order("name", { ascending: true });
    if (error) throw error;
    return (data ?? []) as AnnouncementCategory[];
  } catch {
    // Respaldo con categorías de ejemplo si la tabla no está disponible.
    return mockCategories.map((c, i) => ({
      id: i + 1,
      name: c.name,
      slug: c.id,
      description: null,
      icon: c.icon,
      image_url: null,
      parent_id: null,
      sort_order: i,
      is_active: true,
    }));
  }
}

/** Devuelve solo las categorías de primer nivel (sin padre). */
export function topLevelCategories(
  all: AnnouncementCategory[]
): AnnouncementCategory[] {
  return all.filter((c) => c.parent_id === null && c.is_active);
}

/** Devuelve las subcategorías hijas de una categoría padre. */
export function subcategoriesOf(
  all: AnnouncementCategory[],
  parentId: number | null | undefined
): AnnouncementCategory[] {
  if (!parentId) return [];
  return all.filter((c) => c.parent_id === parentId && c.is_active);
}

/** Resuelve el nombre legible de una categoría por su id. */
export function categoryNameById(
  all: AnnouncementCategory[],
  id: number | null | undefined
): string | null {
  if (!id) return null;
  const found = all.find((c) => c.id === id);
  return found?.name ?? null;
}